import ApiService from '@/helpers/api.service';

const API = new ApiService();

const ENDPOINT = 'subscriber/profile';

export const state = {
  errors: null
}

export const mutations = {
  SET_ERROR(state, errors){
    state.errors = errors;
  },
}

export const actions = {
  // {
  //   action: "action",
  //   body: {"obj":obj}
  // }
  actionCIF(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/${ENDPOINT}/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data)
          } else {
            reject(data.message)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ERROR', response.data.errors);
          reject();
        });
    });
  }
}

export const getters = {}